import { jwtDecode } from 'jwt-decode';

import { IAuthApiState } from '../types/authSlice.types';
import { getCookie } from '../../utils/cookieFuns';

let decoded = {
    UserProfile: '',
};

try {
    decoded = jwtDecode(getCookie('session') ?? '');
} catch (error) { /* empty */ }

export const AUTH_INITIAL_STATE: IAuthApiState = {
    data: decoded?.UserProfile ? JSON.parse(decoded?.UserProfile) : {},
    loading: 'idle',
    error: null,
    eSign: '',
};